import React, { Component } from "react";

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Input from '@material-ui/core/Input';
import TextField from '@material-ui/core/TextField';

class Context extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.gotoError = this.gotoError.bind(this);
	}
	
	handleClick(e){
		if(this.props.accio!=null){
//			console.log("Context.handleClick: " + this.props.iTu+","+this.props.iSeg)
			this.props.accio(this.props.iTu, this.props.iSeg);
		}else{
//			console.log("Context.handleClick: this.props.accio es null");
		}
	}
	
	gotoError(e, iTu, iSeg, i){
		e.stopPropagation();
		e.preventDefault();
		this.props.handleGotoError(iTu, iSeg, i+this.props.firstSpellErrorIndex);
	}
	
	render() {
		//console.log("context RENDER:");
		//console.log(this.props);
		var segments=[];
//		let i=0;
		var tag;
		var backround;
		let text=this.props.segment.text;
		let newText=[];
		let inici=0;
		let wordbreakClass="";
		if(this.props.showInvChars>0){
			//text=text.replace(/\s/g,"·");
			text=text.replace(/ /g,"·");
			text=text.replace(/\t/g,'\u2192');
			wordbreakClass = "wordbreak"
			//hyphenate-character: '·';
		}
		if( (typeof this.props.spellErrors !=='undefined') && (this.props.spellErrors!==null) ){
			if(!this.props.original){
				let tempText="";
				for(let i=0; i<this.props.spellErrors.length; i++) {
					newText.push(<span>{text.slice(inici, this.props.spellErrors[i].offset)}</span>);
					newText.push(<span class="spell_error" onClick={(e) => this.gotoError(e, this.props.iTu, this.props.iSeg, i)}>{text.slice(this.props.spellErrors[i].offset, this.props.spellErrors[i].offset+this.props.spellErrors[i].length, i)}</span>);
					inici=this.props.spellErrors[i].offset+this.props.spellErrors[i].length;
				}
				newText.push(<span>{text.slice(inici, text.length)}</span>);
			}
		}else{
			//TAGS
			for(let j=0; j<this.props.segment.tags.length; j++) {
				//if(visibleTag(j)){
					newText.push(<span>{text.slice(j>0 ? this.props.segment.tags[j-1].position:0, this.props.segment.tags[j].position)}</span>);
					switch(this.props.segment.tags[j].type){
						case "OPEN":
							//tag="<span class=tagO>"+this.props.segment.tags[j].id+"</span>"
							if(j == this.props.tagSeleccionat){
								tag=<span class="tagOS">{this.props.segment.tags[j].code}</span>
							}else{
								tag=<span class="tagO">{this.props.segment.tags[j].code}</span>
							}
							break;
						case "CLOSE":
							if(j == this.props.tagSeleccionat){
								tag=<span class="tagCS">{this.props.segment.tags[j].code}</span>
							}else{
								tag=<span class="tagC">{this.props.segment.tags[j].code}</span>
							}
							break;
						case "ALONE":
							if(j == this.props.tagSeleccionat){
								tag=<span class="tagAS">{this.props.segment.tags[j].code}</span>
							}else{
								tag=<span class="tagA">{this.props.segment.tags[j].code}</span>
							}
							break;
					}
					newText.push(tag);
				//}
			}
			if(this.props.segment.tags.length>0){
				inici = this.props.segment.tags[this.props.segment.tags.length-1].position;
			}else{
				inici = 0;
			}
			newText.push(<span>{text.slice(inici, text.length)}</span>);
			
			//// GLOSSARY
			//if(this.props.glossary){
			//	console.log(newText);
			//	let newTextGlossary=[];
			//	for(let i=0; i<newText.length; i++) {
			//		console.log(i);
			//		console.log(newText[i]);
			//		let trobats = {};
			//		let trobats_order = [];
			//		if(newText[i].props && newText[i].props.children && typeof newText[i].props.children === 'string' && newText[i].props.children!=""){
			//			Object.entries(this.props.glossary).forEach(([key, value]) => {
			//				let index = newText[i].props.children.toLowerCase().indexOf(key.toLowerCase());
			//				if(index>-1){
			//					trobats.push({key: index});
			//					//if(trobats[index] === undefined || trobats[index].length<key.length){
			//					//	trobats[index]=key;
			//					//}
			//				}
			//				//newText[i].props.children=newText[i].props.children.replace(key, "<span class=\"glossary\">"+key+"</span>");
			//			});
			//			if(trobats.length>0){
			//				tag=<span>{newText[i].props.children.substring(0, 1)}</span>
			//				newTextGlossary.push(tag);
			//				
			//				for(let j=0; j<trobats.length; j++) {
			//					tag=<span class="glossary">key</span>
			//					newTextGlossary.push(tag);
			//				}
			//				
			//				
			//			}else{
			//				newTextGlossary.push(newText[i]);
			//			}
			//		}else{
			//			newTextGlossary.push(newText[i]);
			//		}
			//	}
			//	newText = newTextGlossary;
			//}
		}
		// Style
		//let bg_color="#eeecec";
		let bg_color="#f4f6f6";
		let padding="15px 10px";
		let fontsize="18px";
		let color="#001f3d";
		if(this.props.tmxMatch>99){
			color="#0000FF";
		}else if(this.props.tmxMatch>75){
			color="#2E9AFE";
		}else if(this.props.isRepetition){
			color="#239b56";
		}else if(this.props.isRepetitionSrc){
			color="#f1c40f";
		}else{
			color="#001f3d";
		}
		if(this.props.current){
			bg_color="#FFF";
			padding="30px 16px 16px 16px";
			fontsize="21px";
		}
		if(!this.props.original){
			//bg_color="#d6eaf8";
			bg_color="#f4f6f6";
		}
		return (
			<Grid onClick={this.handleClick} container item direction="column" justify="flex-start" alignItems="center" xs={12} spacing={0}>
				<Grid container item direction="row" justify="center" alignItems="center" xs={12} spacing={0}>
					<Grid item xs={12}>
						<Box color={color} bgcolor={bg_color} padding={padding} fontSize={fontsize} lineHeight="normal" className={wordbreakClass}>{newText}</Box>
					</Grid>
				</Grid>
			</Grid>
		);
	}
}

export default Context;